import React from 'react'
import styled from 'styled-components'

import { formatAsCurrencyOrZero } from '../../../../../../utils/priceTools'
import { OrderItemEntryData } from '../types'
import * as Styled from './styled'

import productPlaceholderImage from '../../../../../../img/product-image-placeholder.png'

export interface OrderItemEntryNoProductProps {
  className?: string
  item: OrderItemEntryData
  printDiscountColumn: boolean
}

const OrderItemEntryNoProduct: React.FC<OrderItemEntryNoProductProps> = ({
  className,
  item,
  printDiscountColumn,
}) => {
  return (
    <div className={className}>
      <Styled.GapContainer>
        <Styled.ItemDetails>
          <Styled.ItemImage alt="" className="item-image" src={productPlaceholderImage} />
          <Styled.PrintContainer>
            <Styled.ItemNameNoProduct>{`Item with SKU ${item.sku}`}</Styled.ItemNameNoProduct>
            <Styled.ItemAttributeNoProduct>
              <Styled.ItemAttributeType>Ordered:</Styled.ItemAttributeType>
              {item.quantity}
            </Styled.ItemAttributeNoProduct>
            <Styled.ItemAttributeNoProduct>
              <Styled.ItemAttributeType>Invoiced:</Styled.ItemAttributeType>
              {item.quantityInvoiced}
            </Styled.ItemAttributeNoProduct>
            <Styled.ItemAttributeNoProduct>
              <Styled.ItemAttributeType>Shipped:</Styled.ItemAttributeType>
              {item.quantityShipped}
            </Styled.ItemAttributeNoProduct>
            <Styled.ItemAttributeNoProduct>
              <Styled.ItemAttributeType>Unit Price:</Styled.ItemAttributeType>
              {formatAsCurrencyOrZero({ amount: item.rate })}
            </Styled.ItemAttributeNoProduct>
            <Styled.ItemAmountNoProduct>
              <Styled.ItemAttributeType>Amount:</Styled.ItemAttributeType>
              {formatAsCurrencyOrZero({ amount: item.amount })}
            </Styled.ItemAmountNoProduct>
            {item.discountAmount > 0 && (
              <Styled.ItemAmountNoProduct>
                <Styled.ItemAttributeType>Discount:</Styled.ItemAttributeType>
                {formatAsCurrencyOrZero({ amount: item.discountAmount * -1 })}
              </Styled.ItemAmountNoProduct>
            )}
            {!(item.discountAmount > 0) && printDiscountColumn && (
              <Styled.ItemAmountPrintOnly>-</Styled.ItemAmountPrintOnly>
            )}
          </Styled.PrintContainer>
        </Styled.ItemDetails>
      </Styled.GapContainer>
    </div>
  )
}

const StyledOrderItemEntryNoProduct = styled(OrderItemEntryNoProduct)`
  background-color: ${({ theme }) => theme.colors.grayscale.white};
  overflow: hidden;
  padding: 20px;
  @media print {
    display: contents;
  }
`

export { StyledOrderItemEntryNoProduct as OrderItemEntryNoProduct }
